import React from 'react';

import _ from 'lodash';
import { removeNotification } from '../../actions/ErrorActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


function Notification(props) {
  let debounceRemove = _.debounce(props.removeNotification, 5000);

  debounceRemove(props.index);

  return (
    <div className={`notification is-${props.type}`} style={{ width: '100%', marginLeft: 'auto', paddingRight: '2.5rem' }}>
      <button className="delete" onClick={() => { debounceRemove.cancel(); props.removeNotification(props.index) }}></button>
      <p dangerouslySetInnerHTML={{ __html: props.message }}></p>
  </div>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ removeNotification }, dispatch);
}

export default connect(null, mapDispatchToProps)(Notification);


// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js